import Image from "aldoo-ra/Image"

export default function LogoIcon() {
  return (
    <Image
      id="product_logo_icon"
      alt="Aldoo Snap"
      className="w-full h-auto shrink-0"
    />
  )
}
